<template>
  <div class="app-wrapper">
    <!-- 导航栏 -->
    <Navbar />

    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/layout/Navbar.vue'
import Footer from '@/layout/Footer.vue'

export default {
  name: 'AppLayout',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style scoped>
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
</style>